// -----------------------------------------------------------------
// JavaScript for the Newsletter Signup Grid Editor
// -----------------------------------------------------------------

TECL_NLSignup = {

    // Initialise the newsletter control
    Initialise: function() {

        var nlSignupForms = $(".newsletterSignup");

        if ($(".newsletterSignup").length > 0) {

            nlSignupForms.submit(function(e) {
                TECL_NLSignup.SignUp($(this));

                // Prevent default submit action
                e.preventDefault();
            });

            nlSignupForms.each(function() {

                var form = $(this);

                TECL_NLSignup.PopulateNewsletters(form);

                form.find(".nlSignup-success button, .nlSignup-fail button").click(function() {
                    // When the button on the success of fail view is clicked, return to the entry form
                    TECL_NLSignup.SetFormState(form, "ENTRY");
                });
            });
        }
    },

    // Populate a news letter sign up form
    PopulateNewsletters: function(form) {

        if (form && form.length > 0) {

            if (TECL_Master.AddLock("newslettersPopulate"))
                $.ajax({
                    url: "/umbraco/Surface/NewsletterSignupSurface/Populate",
                    type: "POST",
                    data: {
                        tagContainerId: form.attr("data-tagContainerId")
                    },
                    error: function() {
                        TECL_Master.ClearLock("newslettersPopulate");
                    },
                    success: function(newsletters) {
                        TECL_Master.ClearLock("newslettersPopulate");

                        TECL_NLSignup.CreateNewsletterItems(newsletters, form);
                    }
                });
        }
    },

    // Add newsletter items
    CreateNewsletterItems: function(newsletters, form) {

        if (newsletters) {

            form.find(".nlSignup-nlItems").empty();

            newsletters.forEach(function(item) {
                var nlItem = TECL_NLSignup.CreateNewsletterItem(item);
                form.find(".nlSignup-nlItems").append(nlItem);
            });
        }
    },

    // Create a newsletter item
    CreateNewsletterItem: function(newsletter) {

        var nlItem = null;

        if (newsletter) {
            nlItem = "<label class='nlSignup-nlItem'><input type='checkbox' name='nlSignup-newsletter' value='" + newsletter.Id + "' />" + newsletter.TagName + "</label>";
        }

        return nlItem;
    },

    // Validate a newsletter form
    Validate: function(form) {

        var isValid = false;

        if (form && form.length > 0) {

            form.find(".nlSelectError").addClass("hidden");
            form.find(".nlEmailError").addClass("hidden");

            // Standard validation
            isValid = TECL_MandatoryFields.Validate(form);

            // Check box validation, make sure at least one newsletter is selected
            var nlSelected = form.find("[name='nlSignup-newsletter']:checked").length;
            if (nlSelected === 0) {
                form.find(".nlSelectError").removeClass("hidden");
                isValid = false;
            }

            // If an email address is present, make sure it is a valid email address
            var email = form.find("[name='nlSignup-email']").val();
            if (email) {
                if (!TECL_MandatoryFields.ValidateEmailAddressText(email)) {;
                    form.find(".nlEmailError").removeClass("hidden");
                    isValid = false;
                }
            }
        }

        return isValid;
    },

    // Sign up the user using 
    SignUp: function(form) {

        if (TECL_NLSignup.Validate(form)) {

            if (TECL_Master.AddLock("newsletterSignup")) {

                var name = form.find("[name='nlSignup-name']").val();
                var email = form.find("[name='nlSignup-email']").val();

                var newsletters = [];
                form.find("[name='nlSignup-newsletter']:checked").each(function() {
                    newsletters.push(this.value);
                });

                // Sign up to selected newsletters
                $.ajax({
                    url: "/umbraco/Surface/NewsletterSignupSurface/Signup",
                    type: "POST",
                    data: {
                        name: name,
                        emailAddress: email,
                        newsletters: newsletters,
                        tagContainerId: form.attr("data-tagContainerId")
                    },
                    error: function() {
                        TECL_Master.ClearLock("newsletterSignup");
                    },
                    success: function(result) {
                        TECL_Master.ClearLock("newsletterSignup");

                        if (result) {
                            TECL_NLSignup.SetFormState(form, "SUCCESS");
                        } else {
                            TECL_NLSignup.SetFormState(form, "FAIL");
                        }
                    }
                });
            }
        }
    },

    // Set the state of the form (ENTRY, SUCCESS or FAIL)
    SetFormState: function(form, state) {

        if (form && form.length > 0) {

            form.children("div").addClass("hidden");

            switch (state) {
                case "ENTRY":
                    {
                        TECL_NLSignup.ClearForm(form);
                        form.find(".nlSignup-entry").removeClass("hidden");
                        break;
                    }
                case "SUCCESS":
                    {
                        form.find(".nlSignup-success").removeClass("hidden");
                        break;
                    }
                case "FAIL":
                    {
                        form.find(".nlSignup-fail").removeClass("hidden");
                        break;
                    }
            }
        }
    },

    // Clear a form ready for entry
    ClearForm: function(form) {

        if (form && form.length > 0) {
            form.find("input:text").val("");
            form.find("input:checkbox").prop("checked", false);
        }
    }
};